//client/src/components/plataforma/siteInstitucional/FaqFormPage.js
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFaqs } from '../../../hooks/useFaqs';
import useAlert from '../../../hooks/useAlert';
import { Save, Loader2, HelpCircle } from 'lucide-react';
import PageHeader from '../../layout/PageHeader';
import FabSaveButton from '../../common/FabSaveButton';
import GerarTextoIABox from '../../ai/GerarTextoIABox';

const FaqFormPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEditing = !!id;
    // ✅ O hook agora fornece a função 'getFaq'
    const { getFaq, createFaq, updateFaq, loading } = useFaqs();
    const { setAlert } = useAlert();

    const [formData, setFormData] = useState({
        question: '',
        answer: '',
        category: 'geral',
        status: 'published',
        order: 0
    });
    
    const categories = ['geral', 'planos', 'pagamentos', 'tecnico', 'contratos', 'agendamentos', 'suporte', 'outros'];

    // ✅ Lógica de busca de dados corrigida
    const fetchFaqData = useCallback(async () => {
        if (isEditing) {
            try {
                const result = await getFaq(id);
                if (result.data) {
                    setFormData(result.data);
                }
            } catch (err) {
                setAlert(`Erro ao carregar FAQ: ${err.message}`, 'error');
                navigate('/site-institucional/faq'); // Volta para a lista se não encontrar a FAQ
            }
        }
    }, [id, isEditing, getFaq, setAlert, navigate]);

    useEffect(() => {
        fetchFaqData();
    }, [fetchFaqData]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await updateFaq(id, formData);
            } else {
                await createFaq(formData);
            }
            setAlert(`FAQ salva com sucesso!`, 'success');
            navigate('/site-institucional/faq');
        } catch (err) {
            setAlert(`Erro ao salvar FAQ: ${err.message}`, 'error');
        }
    };

    return (
        <div className="page-management-container">
            <form onSubmit={handleSubmit}>
                {/* ✅ Cabeçalho padronizado com o PageHeader */}
                <PageHeader
                    title={isEditing ? 'Editar FAQ' : 'Nova FAQ'}
                    icon={<HelpCircle className="icon-title" />}
                    navBack={{ to: '/site-institucional/faq', text: 'Voltar' }}
                />

                <div className="content-panel mt-6">
                    <GerarTextoIABox
                        endpoint="/admin/institucional/faqs/gerar-ia"
                        extraPayload={{ category: formData.category, quantidade: 1 }}
                        placeholder='Descreva o tema da pergunta — ex: "como funciona o cancelamento de agendamento"'
                        successMessage="Pergunta gerada! Revise antes de salvar."
                        onGenerated={(data) => {
                            const gerada = Array.isArray(data) ? data[0] : data;
                            if (!gerada) return;
                            setFormData(prev => ({ ...prev, question: gerada.question, answer: gerada.answer }));
                        }}
                    />
                    <div className="form-grid-container grid-cols-1">
                        <div className="form-group">
                            <label htmlFor="question">Pergunta*</label>
                            <input type="text" id="question" name="question" value={formData.question} onChange={handleChange} className="form-input" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="answer">Resposta*</label>
                            <textarea id="answer" name="answer" value={formData.answer} onChange={handleChange} className="form-input" rows="8" required />
                        </div>
                        <div className="form-grid-container grid-cols-1 md:grid-cols-2">
                            <div className="form-group">
                                <label htmlFor="category">Categoria*</label>
                                <select id="category" name="category" value={formData.category} onChange={handleChange} className="form-input capitalize">
                                    {categories.map(cat => (
                                        <option key={cat} value={cat}>{cat}</option>
                                    ))}
                                </select>
                            </div>
                             <div className="form-group">
                                <label htmlFor="status">Status</label>
                                <select id="status" name="status" value={formData.status} onChange={handleChange} className="form-input">
                                    <option value="published">Publicado</option>
                                    <option value="draft">Rascunho</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <FabSaveButton loading={loading} label="Salvar" />
            </form>
        </div>
    );
};

export default FaqFormPage;